import {useEffect, useState} from "react"
import {getLocalStorage, setLocalStorage} from "../utils/LocalStorage"

export interface IGeopIPData {
  currency?: {
    code: string;
  }
  country_code?: string;
}


export function useGeoIPLookup() {
  const STORAGE_KEY = "geoIP1583965106"
  const [data, setData] = useState<IGeopIPData>({})
  const [errors, setErrors] = useState({})

  async function queryGeoIPProvider() {
    const url = new URL("https://api.ipstack.com/check")
    const params = {
      access_key: process.env.GATSBY_IPSTACK_KEY,
      fields: "country_code,currency.code",
    }
    Object.keys(params).forEach(key =>
      url.searchParams.append(key, params[key])
    )

    fetch(url)
      .then(response => {
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json().then(responseData => {
            // console.log("setting to ", responseData)
            setLocalStorage(STORAGE_KEY, JSON.stringify(responseData))
            setData(responseData)
          }).catch(err => setErrors(err))
        } else {
          return false
        }
      })
  }

  async function fetchData() {
    // console.log('fetching geoip data')
    try {
      let hasgeoIP =
        getLocalStorage(STORAGE_KEY) &&
        JSON.parse(getLocalStorage(STORAGE_KEY)) &&
        JSON.parse(getLocalStorage(STORAGE_KEY))

      if (hasgeoIP) {
        // console.info('has geoIP in session', JSON.parse(getLocalStorage("geoIP")))
        setData(JSON.parse(getLocalStorage(STORAGE_KEY)))
      } else {
        // console.info('no geoIP data found in storage')
        queryGeoIPProvider()
      }
    } catch (e) {
      console.error(e)
      queryGeoIPProvider()
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  return {data: data || {}, errors: errors}
}
